import React from "react";
import { useTranslation } from "react-i18next";
import { SearchIcon } from "../Icons";
import { SearchContainer, SearchInput } from "./Search.styled";

interface SearchProps {
  placeholder?: string;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  fullWidth?: boolean;
  width?: string | number;
}

const Search: React.FC<SearchProps> = ({
  placeholder,
  value,
  onChange,
  onFocus,
  onBlur,
  disabled = false,
  fullWidth = false,
  width,
}) => {
  const { t } = useTranslation();
  const defaultPlaceholder = placeholder || t("search.placeholder");

  return (
    <SearchContainer
      sx={{
        width: fullWidth ? "100%" : width,
      }}
    >
      <SearchIcon width="18px" height="18px" fill="#6B7A94" />
      <SearchInput
        placeholder={defaultPlaceholder}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        disabled={disabled}
        fullWidth
      />
    </SearchContainer>
  );
};

export default Search;
